import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button} from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext';
import { usePost } from '../../../apis/ApiRequests';
import Header from '../../../components/uiParts/port/Header';
import TitleBar from '../../../components/uiParts/TitleBar';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import MenuIcon from '../../../components/uiParts/MenuIcon';

const PortMastaMenu = () => {
    
    const { authInfo, setAuthInfo } = useAuth();
    const navigate = useNavigate();

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode = authInfo.facilityCode;
    const facilityName = authInfo.facilityName;
    const userId       = authInfo.userId;
    const userName     = authInfo.userName;
    const authority    = authInfo.authority;
    const traderCode   = authInfo.traderCode;
    const trader       = authInfo.trader;
    
	//===============================================
	// API
	//===============================================
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {
    },[])

    //===============================================
    // eventHandler
    //===============================================
    const handleClick = (url) => {
        navigate(url);
    };
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
	//===============================================
	// Function
	//===============================================
	//===============================================
	// UI Message
	//===============================================
	//===============================================
	// イベントハンドラ
	//===============================================
    //===============================================
    // Css
    //===============================================
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/portHome" setEntryDate={handleChange_entryDate} />
            <div className='menu' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                <div>
                    <TitleBar title="入船管理マスタメニュー" color="#006400" />
                    <MenuIcon header="maintenance Menu" title="漁業者マスタ"  onClick={() => handleClick('/fisherManList')} color="#006400">
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#006400'}} />
                    </MenuIcon>
                </div>
            </div>
        </>
    )
}
export default PortMastaMenu;